import LocalizedStrings from 'react-localization';

const Strings = new LocalizedStrings({
    ar: {
        username: "أسم المستخدم",
        password: "كلمة المرور",
        signIn: "تسجيل دخول",
        loginToYourShopsWithTalabatey: "سجل دخول الى متاجرك مع طلباتي",
        lang: "اللغة",
        logout: "تسجيل خروج",
        invalidUserNameOrPassword: "أسم المستخدم او كلمة المرور غير صحيحة",
        dir: "left",
        choseLocation: "تحديد الموقع",
        createOrder: "أنشاء الطلب",
        submit: "تثبيت الطلب",
        selectTheCity: "أختر المحافظة",
        selectTheDistrict: "اختر منطقة التوصيل",
        street: "المحلة",
        building: "الدار",
        apartment: "الزقاق",
        save: "حفظ",
        codeVerification: "رمز التحقق",
        additionalInformationAboutLocation: "معلومات أضافية عن الموقع",
        mentionAdditionalInformation: "أذكر معلومات أضافية عن موقعك الحالي أن وجدت",
        determineTime: "تحديد الوقت",
        track: "تعقب",
        choseYourLocation: "أختر موقعك",
        choseTheSimDeliveryLocation: "أختر موقع تسليم الشريحة",
        requiredDocumentsAndInstructions: "يرجى تواجدكم في موقع التوصيل لأجراء عملية الأستبدال مع تهيئة المستمكات المطلوبة: النسخة الأصلية من هوية الاحوال المدنية او البطاقة الوطنية الموحدة او جواز السفر علما ان المالك الحقيقي للشريحة هو الشخص المخول حصرا بطلب واجراء الأستبدال.",
        moreDetails: "تفاصيل أكثر",
        loadingYourLocation: "يتم تحميل موقعك, يرجى الأنتظار",
        selectTheDeliveryTime: "أختر وقت توصيل الشريحة",
        locationNotSupported: "نعتذر لم يتم تغطية هذه المنطقة بعد ولكن نحن نعمل على ذلك! يمكنك اختيار عنوان اخر او قم بزيارة احدى مراكز خدمات ومبيعات زين لاستبدال شريحتك",
        fieldRequired: "حقل {field} مطلوب",
        autoLocationSelect: "تحديد الموقع تلقائيا",
        previous: "السابق",
        orderCanceled: "الطلب ملغي",
        loadingRaised: "جاري التحميل",
        trackAndReplaceYourSim: "تعقب وبدل شريحتك",
        deliveryLocation: "موقع التسليم",
        deliveryTime: "وقت التوصيل المتوقع",
        edit: "تعديل",
        orderStatus: "حالة الطلب",
        orderInReview: "يتم مراجعة المعلومات",
        driverAssigned: "السائق في الطريق إليك",
        cancelOrder: "إلغاء الطلب",
        cancelConfirm: "هل من انت متأكد من  رغبتك بألغاء الطلب؟",
        orderHasCancel: "تم إلغاء الطلب",
        cannotCancel: "لا يمكن إلغاء الطلب, تم تعيين سائق",
        locationPermissionDenied: "صلاحية الوصول التلقائي لموقعك ألغيت, يرجى تحديد الموقع من الخريطة",
        noShopAvailable: "لا يوجد سواق متوفرين ضمن هذا الوقت حاول مجددا",
        invalidHour: "لا يمكن التوصيل ضمن الساعة المختارة, حاول اختيار ساعة اخرى",
        cannotEditOrDeleteIfDriverAssigned: "لا يمكن الغاء او تعديل الطلب عند تعيين سائق",
        yourLocation: "موقعك الحالي",
        driverLocation: "موقع السائق",
        okay: "نعم",
        cancel: "كلا",
        lockedOrder: "الطلب مقفل",
        completedOrder: "الطلب مكتمل",
        simDelivered: "تم توصيل شريحتك بنجاح",
        updateStatus: "تحديث الحالة",
        canUpdateAfterCountdownSeconds: "يمكن طلب تحديث الحالة بعد انتهاء العد",
        driverGoingToPickupSim: "السائق متوجه لجلب الشريحة",
        driverLocationWillShow: "سيظهر موقع السائق في الخريطة عندما يتم التوجه الى موقعك",
        callDriver: "أتصل بالسائق",
        editDeliveryTime: "تعديل وقت التوصيل",
        editLocation: "تعديل الموقع",
        enterLocationDetail: "أدخل تفاصيل الموقع",
        select: "أختر {keyword}",
        city: "المحافظة",
        district: "منطقة التوصيل",
        selectInsidePolygon: "يرجى تحديد موقعك الحالي داخل منطقة التوصيل فقط والمضللة باللون الأحمر",
        searchAddress: "أبحث عن عنوان",
        selectToOpenMap: "أختر المحافظة و المدينة لفتح الخريطة وتحديد موقعك او أستخدم شريط البحث بصورة مباشرة ",
        locationFromPermissionNotValid: "موقعك المحدد تلقائيا غير مدعوم في الموقت الحالي من طلباتي, يرجى تحديد موقع أخر عن طريق البحث او تحديد المحافظة و منطقة التوصيل",
        waitingForAssigningDriver: "بانتظار تعيين سائق",
        optional: "أختياري",
        required: "مطلوب"

    },
    en: {
        username: "username",
        password: "password",
        signIn: "sign in",
        loginToYourShopsWithTalabatey: "Login to your shops with Talabatey",
        lang: "Language",
        logout: "logout",
        invalidUserNameOrPassword: "invalid username or password",
        dir: "right",
        choseLocation: "chose location",
        createOrder: "create order",
        submit: "submit",
        selectTheCity: "select the city",
        selectTheDistrict: "select the delivery district",
        street: "street",
        building: "building",
        apartment: "apartment",
        save: "save",
        codeVerification: "code verification",
        additionalInformationAboutLocation: "additional information's about location",
        mentionAdditionalInformation: "type additional information's about your current location",
        determineTime: "determine time",
        track: "track",
        choseYourLocation: "chose your location",
        choseTheSimDeliveryLocation: "select the sim pick up location",
        requiredDocumentsAndInstructions: "Please be present at the delivery location and make sure you carry out the following required documents: the original copy of the civil status identity, the unified national card or the passport, note that the real owner of the sim card is the only person who authorized to do the replacement.",
        moreDetails: "more details",
        loadingYourLocation: "Loading your location, please wait",
        selectTheDeliveryTime: "select the sim delivery time",
        locationNotSupported: "We apologize that this area has not been covered yet but we are working on it! You can choose another address or visit one of the service and sales centers of Zain to replace your SIM card.",
        fieldRequired: "{field} field is required",
        autoLocationSelect: "auto location detect",
        previous: "previous",
        orderCanceled: "order has canceled",
        loadingRaised: "loading",
        trackAndReplaceYourSim: "track and replace your sim card",
        deliveryLocation: "delivery Location",
        deliveryTime: "expected delivery time",
        edit: "edit",
        orderStatus: "order status",
        orderInReview: "order is being checked",
        driverAssigned: "the driver is on the way to you",
        cancelOrder: "cancel the order",
        cancelConfirm: "are you sure to cancel the order?",
        orderHasCancel: "the order has canceled",
        cannotCancel: "driver assigned can not cancel the order",
        locationPermissionDenied: "access to your location permission have denied, please specify it manually from map",
        noShopAvailable: "sorry, there is no drivers available right now, try again later",
        invalidHour: "can not deliver at this hour, try choosing other hour",
        cannotEditOrDeleteIfDriverAssigned: "cannot delete or edit the order when assigned to a driver",
        yourLocation: "your location",
        driverLocation: "driver location",
        okay: "okay",
        cancel: "cancel",
        lockedOrder: "locked order",
        completedOrder: "completed order",
        simDelivered: "your sim card has delivered successfully",
        updateStatus: "update status",
        canUpdateAfterCountdownSeconds: "you can request update after the countdown is over",
        driverGoingToPickupSim: "driver is picking up the sim",
        driverLocationWillShow: "The driver's location will appear on the map when he is going to your location",
        callDriver: "call driver",
        editDeliveryTime: "edit the delivery time",
        editLocation: "edit the location",
        enterLocationDetail: "fill the location details",
        select: "select the {keyword}",
        city: "city",
        district: "district",
        selectInsidePolygon: "please pick the location inside the delivery district only which is shadowed by the red color",
        searchAddress: "search address",
        selectToOpenMap: "select the city and the delivery district to open the map and select your location or use the search bar directly",
        locationFromPermissionNotValid: "your auto detected location is currently not supported by Talabatey, please select another location using the search bar or by selecting the city and the district",
        waitingForAssigningDriver: "waiting for assigning a driver",
        optional: "optional",
        required: "required"
    },
    ku: {
        username: "ناوی بەکارهێنەر  ",
        password: "وشەی تێپەڕین  ",
        signIn: "چوونە ژوورەوە",
        loginToYourShopsWithTalabatey: "چوونە ژوورەوە تۆماربکە بۆ کۆگاکانت لە تەڵەباتی ",
        lang: "زمان",
        logout: "چوونە دەرەوە",
        invalidUserNameOrPassword: "ناوی بەکارهێنەر یاخود پاسۆردەکە هەڵەیە",
        dir: "left",
        choseLocation: "هەڵبژاردنی پێگە ",
        createOrder: "دروستکردنی داوا ",
        submit: "جێگیرکردنی داواکە",
        selectTheCity: " پارێزگاکە هەڵبژێرە",
        selectTheDistrict: "گەیاندن بۆ گەڕەک دیاریبکە دیاریبکە",
        street: "گەڕەک",
        building: "بینا",
        apartment: "شوقە",
        save: "سەیڤکردن",
        codeVerification: "کۆدی سەلماندن ",
        additionalInformationAboutLocation: "زانیاری زیاتر لەسەر پێگەکەت ",
        mentionAdditionalInformation: "زانیاری زیاتر بنوسە لەسەر پێگەکەت گەر هەبوو",
        determineTime: "دیاریکردنی کات",
        track: "شوێنکەوتن",
        choseYourLocation: "پێگەکەت دیاریبکە",
        choseTheSimDeliveryLocation: "شوێنی وەرگرتنی سیمکارتەکە دیاریبکە ",
        requiredDocumentsAndInstructions: "تکایە لە پێگەی گەیاندن ئامادەیان بۆ ئەنجامدانی کرداری گۆڕین و لەگەڵ ئامادەکردنی هەموو ئەو بەڵگەنامانەی پێویستن :کۆپی ئەسڵی بۆ تەسکەرە و کارتی نیشتمانی و یان جەوازی سەفەر بۆ زانیاری تەنها خاوەنی ڕاستەقینەی سیمکارتەکە مافی هەیە داوای گۆڕینەکە بکات   .",
        moreDetails: "وردەکاری زیاتر  ",
        loadingYourLocation: "پێگەکەت لەبارکردندایە تکایەچاوەڕێبە",
        selectTheDeliveryTime: "کاتی گەیاندنی سیمکارتەکە هەڵبژێرە",
        locationNotSupported: "ببورە، هێشتا ناوچەکەت رووماڵ نەکراوە، بەڵام کاری لەسەر دەکەین! دەتوانیت ناونیشانێکی تر هەڵبژێری یان سەردانی یەکیك لە سەنتەرەکانی خزمەتگوزاری و فرۆشیاری زین بکە بۆ گۆڕینەوەی سیمکارتەکەت",
        fieldRequired: "خانەی داواکراو {field} ",
        autoLocationSelect: "دیاریکردنی پێکە بە شێوەیەکی ئۆتۆماتیکی",
        previous: "پێشتر ",
        orderCanceled: "داواکە هەڵوەشێندراوەتەوە",
        loadingRaised: "لەبارکردندایە ",
        trackAndReplaceYourSim: "شوێنکەوتن و گۆڕین بۆ سیمکارتەکەت بکە",
        deliveryLocation: "پێگەی گەیاندن ",
        deliveryTime: "کاتی گەیاندنی پێشبینیکراو ",
        edit: "ڕێکخستن",
        orderStatus: "باری داواکە  ",
        orderInReview: "پێداچونەوە بۆ زانیاریەکان دەکرێت ",
        driverAssigned: "شۆفێرەکە لە ڕێگادایە بۆ لای تۆ ",
        cancelOrder: "هەڵوەشاندنەوەی داواکە ",
        cancelConfirm: " ئایا تۆ دڵنیایت لە هەڵوەشاندنەوەی داواکە ؟",
        orderHasCancel: "داواکە هەڵوەشێندرایەوە ",
        cannotCancel: "ناتوانیت داواکە هەڵوەشێنیتەوە ، شۆفێرەکە دیاریکرا ",
        locationPermissionDenied: "تایبەتمەندی گەیشتنی ئۆتۆماتیکی بۆ پێگەکەت هەڵوەشێندرایەوە  تکایە پێگەکەت لەسەر نەخشە دیاری بکە ",
        noShopAvailable: "لەم کاتەدا شۆفێر بەردەست نیە دوبارە هەوڵبدەرەوە",
        invalidHour: "ناتوانرێت داواکە ماوەی ئەو کاتژمێرەی دیاریکراوە بگەیەنرێت تکایە کاتژمێرێکی تر هەڵبژێرە",
        cannotEditOrDeleteIfDriverAssigned: "لەکاتی دەستنیشانکردنی شۆفێرەکە ناتوانرێت داواکە هەڵبوەشێندرێتەوە یاخود دەستکاری بکرێت ",
        yourLocation: "پێگەی ئێستات ",
        driverLocation: "پێگەی سایەقەکە  ",
        okay: "بەڵێ",
        cancel: "نەخێر",
        lockedOrder: "داواکە قفڵ بووە ",
        completedOrder: "داواکە تەواوبووە",
        simDelivered: " سیمکارتەکەت بەسەرکەوتووی گەیەندرا  ",
        updateStatus: "نوێ کردنەوەی بارەکە  ",
        canUpdateAfterCountdownSeconds: "دەتوانیت داوای نوێکردنەوەی بارەکە بکەیت دوای تەواوبوونی بەرەو خوار ژماردن",
        driverGoingToPickupSim: "شۆفێرەکە لەڕێگادایە بۆ هێنانی سیمەکە",
        driverLocationWillShow: "پێگەی شۆفێرەکە لەسەر  نەخشەکە دەردەکەوێت کاتێک بەرەو پێگەی تۆ ئاڕاستە دەکرێت  ",
        callDriver: "أ پەیوەندی بە شۆفێرەکە بکە ",
        editDeliveryTime: "ڕێکخستنی کاتی گەیاندن",
        editLocation: " ڕێکخستنی شوێنەکە",
        enterLocationDetail: "وردەکاری شوێنەکە داخڵ بکە",
        select: "هەڵبژێرە {keyword}",
        city: "هەڵبژێرە",
        district: " ناوچەی گەیاندن",
        selectInsidePolygon: "تکایە شوێنی کڕیارەکە تەنها لەناو ناوچەی دیاریبکە کە بە ڕەنگی سور سێبەرێندراوە",
        searchAddress: "بە دوای ناونیشان بگەڕێ",
        selectToOpenMap: "بۆ کردنەوەی نەهشە و دیاری کردنی شوێنەکەت و شارەکە هەڵبژێرو یاخود بە شێوەیەکی ڕاستەوخۆ لیستی گەڕان بەکار گەیاندن پارێزگا بێنە",
        locationFromPermissionNotValid: "ببورە، هێشتا ناوچەکەت رووماڵ نەکراوە، بەڵام کاری لەسەر دەکەین! دەتوانیت ناونیشانێکی تر هەڵبژێری یان سەردانی یەکیك لە سەنتەرەکانی خزمەتگوزاری و فرۆشیاری زین بکە بۆ گۆڕینەوەی سیمکارتەکەت",
        waitingForAssigningDriver: "چاوەڕوانی دیاریکردنی شۆفێرین",
        optional: "ئارەزوومەندانە",
        required: "داواکراو"
    },
});
export default Strings;
